import { Box, Text } from '@mantine/core';
import { Link, useLocation } from 'react-router';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  label: string;
  description?: string;
  href?: string;
  onClick?: () => void;
};

export function AIActionCard({ label, description, href, onClick }: Props) {
  const location = useLocation();

  const content = (
    <Box
      px="xl"
      py="md"
      onClick={href ? undefined : onClick}
      style={{
        background: 'rgba(0, 0, 0, 0.25)',
        borderRadius: 'var(--mantine-radius-xl)',
        cursor: href || onClick ? 'pointer' : 'default',
      }}
    >
      <Text size="textXl" fw={FONT_WEIGHTS.bold} c="white">
        {label}
      </Text>
      {description && (
        <Text size="sm" c="rgba(255, 255, 255, 0.7)" mt="xxxs">
          {description}
        </Text>
      )}
    </Box>
  );

  if (href) {
    return (
      <Link to={href} state={{ fromPath: location.pathname }} style={{ textDecoration: 'none' }}>
        {content}
      </Link>
    );
  }

  return content;
}
